import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const EDITORIAL_ROLES = ["owner", "administrator"];

export default function EditorialRoute({ children }) {
  const { user, initializing } = useAuth();

  if (initializing) {
    return (
      <div className="grid min-h-screen place-items-center text-sm text-muted-foreground">
        Загрузка…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!EDITORIAL_ROLES.includes(user.role)) return <Navigate to="/hall" replace />;
  return children;
}
